import DialogContentText from '@mui/material/DialogContentText';
import { useTranslation } from 'react-i18next';
import Grid from '@mui/material/Grid';
import MailSentIcon from 'components/Svgs/ASSET-PaperPlane.svg';
import { Dialog, TextV2 } from '@insights-ltd/design-library/components';

type DialogType = 'invite' | 'delete';

type PractitionerInvitedDialogProps = {
  open: boolean;
  onClose: () => void;
  dialogType: DialogType;
};

const textKeys: Record<DialogType, { [key: string]: string }> = {
  invite: {
    title: 'ui.event-management.invite-list.invite-sent-dialog.title',
    body: 'ui.event-management.invite-list.invite-sent-dialog.body',
    button: 'ui.event-management.invite-list.invite-sent-dialog.button',
  },
  delete: {
    title: 'ui.event-management.invite-list.invite-deleted-dialog.title',
    body: 'ui.event-management.invite-list.invite-deleted-dialog.body',
    button: 'ui.event-management.invite-list.invite-deleted-dialog.button',
  },
};

const PractitionerInvitedDialog = ({
  open,
  onClose,
  dialogType,
}: PractitionerInvitedDialogProps) => {
  const { t } = useTranslation();
  const { title, body, button } = textKeys[dialogType];

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="practitioner-invited-dialog-title"
      aria-describedby="alert-dialog-description"
      title={t(title)}
      content={
        <DialogContentText component="div" id="alert-dialog-description">
          <Grid
            sx={(theme) => ({
              gap: theme.spacing(2),
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            })}
          >
            <img alt={t(title)} src={MailSentIcon} aria-hidden />
            <TextV2 component="p">{t(body)}</TextV2>
          </Grid>
        </DialogContentText>
      }
      secondaryButtonText={t(button)}
    />
  );
};

export default PractitionerInvitedDialog;
